import {useSelector} from 'react-redux';
import {AppState} from '../index';
import {UserSettings} from './types';

interface State {
  data: UserSettings;
}

const initialState = {
  data: {
    marketActivity: {
      enabled: false
    },
    labelNew: {}
  }
};

const SET_SETTINGS = '@user-settings/set';

interface SetSettings {
  type: typeof SET_SETTINGS;
  data: UserSettings;
}

type UserSettingsAction = SetSettings;

export const userSettingsReducer = (
  state: State = initialState,
  action: UserSettingsAction,
) => {
  switch (action.type) {
    case SET_SETTINGS:
      return {
        ...state,
        data: action.data
      };

    default:
      return state;
  }
};

export const setUserSettings = (settings: UserSettings) => {
  return {
    type: SET_SETTINGS,
    data: settings,
  };
};

export const getUserSettings = (state: AppState) =>
  state.userSettings.data;

export const useUserSettings = () => {
  return useSelector(getUserSettings);
};
